<script>
    import { default as TopicListItem } from './topic-picker/TopicListItem.svelte'
    import * as immutable from 'object-path-immutable'
    import { createEventDispatcher } from 'svelte'
    import {toggleTopic} from './topic-state'

    const dispatch = createEventDispatcher()

    export let categories

    export let state

    export let activeCategory = categories[0]

    let tmpState = state || {}


    $: console.log("categories", categories);

    function updateState(newState) {
        tmpState = newState;
    }

    function toggleTopicOnOrOff (state, topic) {
        tmpState = toggleTopic(state, topic)
    }

    function close (doChange) {
        if (doChange) {
            dispatch('toggleTopic', {
                newState: tmpState || state
            })
        }

        dispatch('close');
    }

    let pickedCategory

    $: theCategory = pickedCategory || activeCategory || categories[0]

    function handleCategoryClick (i, e) {
        pickedCategory = categories[i];

        e.preventDefault();
        return false;
    }

    $: console.log(theCategory, tmpState)

    $: everyLayerChecked = !categories.some(cat => cat.topics.some(t => !tmpState[t.id]))

    $: categoryTitle = theCategory.title

    $: allChecked = !theCategory.topics.some(t => !tmpState[t.id])

    $: someChecked = !allChecked && theCategory.topics.some(t => tmpState[t.id])

    $: topics = theCategory.topics.map(t => {
      return {
          ...t,
          checked: !!tmpState[t.id]
      }
    })

    function checkAll (category, onOrOff) {
        let newState = tmpState;
        if (onOrOff) {
            category.topics.forEach(t => {
                newState = immutable.set(newState, [t.id], {})
            })

        } else {
            category.topics.forEach(t => {
                newState = immutable.del(newState, [t.id]);
            })
        }
        updateState(newState);
    }

    function checkEveryLayer(onOrOff) {
      categories.forEach(cat => checkAll(cat, onOrOff));
    }

    $: activeCategoryIdx = categories.indexOf(theCategory)

    function included (category, state) {
        return category.topics.filter(t => state[t.id]).length
    }
</script>

<style>
    .topics-picker-container {
        background-color: #f1f1f1;
        padding: 1.5em;
        border-top: 3px solid #2c9abb;
        margin-bottom: 0.5em;
    }
</style>

<h2>
    <i class="icon icon-layers"></i>

    Add or remove report layers

    <i class="icon icon-close_large pull-right color-frag"
        role="button"
        on:click={() => close(false)}
        title="Close without making layer changes"></i>
</h2>

<p style="margin: 1em 0;">
    Select layers to include in your report
</p>

<ul class="nav nav-tabs category-tabs nav-tabs-default">
    {#each categories as category, i}
        <li role="presentation" class:active={i == activeCategoryIdx}>
            <a href data-tab-index={i} on:click={(e) => handleCategoryClick(i, e)}>
                { category.title }
                ({included(category, tmpState)}/{category.topics.length})
            </a>
        </li>
    {/each}
</ul>

<div class="topics-picker-container">
    <ul class="topic-picker-list list-unstyled">
        <li>
            <label>
                <input type="checkbox"
                       on:click={() => checkAll(theCategory, !allChecked)}
                       bind:checked={allChecked}
                       bind:indeterminate={someChecked}/>
                <b> All { categoryTitle || '' } layers</b>
            </label>
        </li>
        {#each topics as topic}
            <li>
                <TopicListItem {topic} on:change={() => toggleTopicOnOrOff(tmpState, topic)}></TopicListItem>
            </li>
        {/each}
    </ul>
</div>

<div class="d-flex">
    <button class="btn-rounded bg-frag-inverse" on:click={() => checkEveryLayer(!everyLayerChecked)}>
        {everyLayerChecked ? 'Exclude' : 'Include'} all layers
    </button>

    <div class="flex-1"></div>

    <button class="btn-rounded bg-frag" on:click={() => close(true)}>
        <b>Update report</b>
    </button>
</div>
